import { MultiSeriesTimeSeriesPlot } from './MultiSeriesTimeSeriesPlot';
import { ReportActions, ReportActionData } from './ReportActions';
import { Report } from '../../types/report.types';
import { DataSet, ColumnId } from '../../types';
import { getColumnNameById } from '../utils/column-utils';

/**
 * MultiSeriesTimeSeriesPlotWithReportActions - レポート機能付きマルチ系列時系列プロット
 * 
 * マルチ系列時系列プロットにレポート作成・追加機能を合成したコンポーネント
 */

interface MultiSeriesTimeSeriesPlotWithReportActionsProps {
  dataset: DataSet;
  dateColumn: ColumnId;
  valueColumns: ColumnId[];
  filteredRowIndices?: number[] | null;
  selectedRows?: number[];
  width?: number;
  height?: number;
  onPointClick?: (dataIndices: number[], isAdditive?: boolean) => void;
  // レポート機能用
  availableReports: Report[];
  onAddToReport: (reportId: string, data: ReportActionData) => void;
  onCreateNewReport: (data: ReportActionData) => void;
}

export function MultiSeriesTimeSeriesPlotWithReportActions({
  dataset,
  dateColumn,
  valueColumns,
  filteredRowIndices,
  selectedRows,
  width,
  height,
  onPointClick,
  availableReports,
  onAddToReport,
  onCreateNewReport
}: MultiSeriesTimeSeriesPlotWithReportActionsProps) {
  // 列IDから列名を取得してタイトルに使用
  const dateColumnName = getColumnNameById(dataset, dateColumn) || dateColumn;
  const valueColumnNames = valueColumns.map(col => getColumnNameById(dataset, col) || col);
  
  // マルチ系列時系列プロット用のアクションデータを作成
  const actionData: ReportActionData = {
    type: 'multi_time_series',
    title: `Multi-Series Time Series: ${dateColumnName} vs [${valueColumnNames.join(', ')}]`,
    multiTimeSeriesData: {
      dateColumn,
      valueColumns,
      dataset
    }
  };

  return (
    <ReportActions
      availableReports={availableReports}
      onAddToReport={onAddToReport}
      onCreateNewReport={onCreateNewReport}
      actionData={actionData}
    >
      <MultiSeriesTimeSeriesPlot
        dataset={dataset}
        dateColumn={dateColumn}
        valueColumns={valueColumns}
        filteredRowIndices={filteredRowIndices}
        selectedRows={selectedRows}
        width={width}
        height={height}
        onPointClick={onPointClick}
      />
    </ReportActions>
  );
}
